import instance from 'api';
import { IRealEstateEvent } from './interfaces';

export const getRealEstateEvents = (realEstateGuid: string, onlyActive: boolean = false) => {
  return instance()
    .post<IRealEstateEvent[]>('/event/list', { realEstateGuid, onlyActive })
    .then((response) => response.data);
};

export const saveRealEstateEvent = (realEstateGuid: string, realEstateEvent: IRealEstateEvent) => {
  return instance()
    .post('/event/save', { ...realEstateEvent, realEstateGuid })
    .then((response) => response.data);
};

export const updateRealEstateEvent = (realEstateGuid: string, realEstateEvent: IRealEstateEvent) => {
  return instance()
    .post(`/event/${realEstateEvent.realEstateEventId}/update`, { ...realEstateEvent, realEstateGuid })
    .then((response) => response.data);
};

export const extendRealEstateEvent = (event: Pick<IRealEstateEvent, 'realEstateEventId' | 'eventEndTime'>) => {
  return instance()
    .post('/event/extend', event)
    .then((response) => response.data);
};

export const closeRealEstateEvent = (realEstateEventId: number) => {
  return instance()
    .post('/event/close', { realEstateEventId })
    .then((response) => response.data);
};

export const deleteRealEstateEvent = (realEstateEventId: number) => {
  return instance()
    .post(`/event/${realEstateEventId}/archive`)
    .then((response) => response.data);
};

export const restoreRealEstateEvent = (realEstateEventId: number) => {
  return instance()
    .post(`/event/${realEstateEventId}/recover`)
    .then((response) => response.data);
};

export const getRealEstateEventTypes = () => {
  return instance()
    .post('/dictionary/eventTypes')
    .then((response) => response.data);
};
